import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kat-branding',
  templateUrl: './kat-branding.component.html',
  styleUrls: ['./kat-branding.component.scss']
})
export class KatBrandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
